import { render, staticRenderFns } from "./agentIncome.vue?vue&type=template&id=795dbc23&scoped=true&"
import script from "./agentIncome.vue?vue&type=script&lang=js&"
export * from "./agentIncome.vue?vue&type=script&lang=js&"
import style0 from "./agentIncome.vue?vue&type=style&index=0&id=795dbc23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dbc23",
  null
  
)

export default component.exports